var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 9",
    width: 16,
    height: 9
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-265 -19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#717375",
    fillRule: "nonzero",
    d: "M273 28a.835.835 0 0 1-.596-.251l-7.157-7.284a.869.869 0 0 1 0-1.214.833.833 0 0 1 1.192 0L273 25.928l6.56-6.677a.833.833 0 0 1 1.193 0c.33.336.33.879 0 1.214l-7.157 7.283A.833.833 0 0 1 273 28z"
  }))));
}

export default SvgChevronDown;